import React from "react"
import types from "prop-types"
import * as API from "services/api"
import { useInterval } from "hooks"
import ActivityIndicator from "shared/ActivityIndicator"
import { errorToast } from "shared/toast"

const REPORT_EXPORT_ERROR_MESSAGE = "Something went wrong.  Unable to get export status."

const ReportExportProcessingCheck = ({
  fetchReportExport = API.reportExport,
  onError,
  reportExportId,
  setReportExport,
}) => {
  useInterval(async () => {
    const response = await fetchReportExport({ reportExportId })

    if (response.ok) {
      setReportExport(response.data)
    } else {
      errorToast(REPORT_EXPORT_ERROR_MESSAGE)
      onError()
    }
  }, 2000)

  return (
    <div className="flex flex-col items-center">
      <ActivityIndicator className="mb-8" />
      <p className="text-center">
        Your export is being processed.<br />
        Download will initiate when your export is ready.
      </p>
    </div>
  )
}

ReportExportProcessingCheck.propTypes = {
  // Task report exports are polled through their own endpoint, since the default one serves only
  // the requesting user's ReportExports.
  fetchReportExport: types.func,
  onError: types.func.isRequired,
  reportExportId: types.number.isRequired,
  setReportExport: types.func.isRequired,
}

export default React.memo(ReportExportProcessingCheck)
